module.exports = __webpack_public_path__ + "img/OmbParkV.6545c4d4.png";